import {
    DISBURSEMENT_LIST_REQUEST,
    DISBURSEMENT_LIST_SUCCESS,
    DISBURSEMENT_LIST_FAIL,
    DISBURSEMENT_CREATE_REQUEST,
    DISBURSEMENT_CREATE_SUCCESS,
    DISBURSEMENT_CREATE_FAIL,
    DISBURSEMENT_CREATE_RESET,
    DISBURSEMENT_DETAILS_REQUEST,
    DISBURSEMENT_DETAILS_SUCCESS,
    DISBURSEMENT_DETAILS_FAIL,
    DISBURSEMENT_UPDATE_REQUEST,
    DISBURSEMENT_UPDATE_SUCCESS,
    DISBURSEMENT_UPDATE_FAIL,
    DISBURSEMENT_UPDATE_RESET,
    DISBURSEMENT_DELETE_REQUEST,
    DISBURSEMENT_DELETE_SUCCESS,
    DISBURSEMENT_DELETE_FAIL,
    DISBURSEMENT_DELETE_RESET,
  } from "../constants/disbursementConstants";
  
  export const disbursementListReducer = (state = { disbursements: [] }, action) => {
    switch (action.type) {
      case DISBURSEMENT_LIST_REQUEST:
        return { ...state, loading: true }; // Preserve existing disbursements while loading
      case DISBURSEMENT_LIST_SUCCESS:
        return { loading: false, disbursements: action.payload };
      case DISBURSEMENT_LIST_FAIL:
        return { loading: false, error: action.payload, disbursements: state.disbursements };
      default:
        return state;
    }
  };
  
  export const disbursementCreateReducer = (state = {}, action) => {
    switch (action.type) {
      case DISBURSEMENT_CREATE_REQUEST:
        return { loadingCreate: true };
      case DISBURSEMENT_CREATE_SUCCESS:
        return { loadingCreate: false, successCreate: true, disbursement: action.payload };
      case DISBURSEMENT_CREATE_FAIL:
        return { loadingCreate: false, errorCreate: action.payload };
      case DISBURSEMENT_CREATE_RESET:
        return {};
      default:
        return state;
    }
  };


  export const disbursementDetailsReducer = (state = { disbursement: {} }, action) => {
    switch (action.type) {
      case DISBURSEMENT_DETAILS_REQUEST:
        return { loading: true, ...state };
      case DISBURSEMENT_DETAILS_SUCCESS:
        return { loading: false, disbursement: action.payload };
      case DISBURSEMENT_DETAILS_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };

  export const disbursementUpdateReducer = (state = {}, action) => {
    switch (action.type) {
      case DISBURSEMENT_UPDATE_REQUEST:
        return { loading: true };
      case DISBURSEMENT_UPDATE_SUCCESS:
        return { loading: false, success: true, disbursement: action.payload };
      case DISBURSEMENT_UPDATE_FAIL:
        return { loading: false, error: action.payload };
      case DISBURSEMENT_UPDATE_RESET:
        return {};
      default:
        return state;
    }
  };

  export const disbursementDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case DISBURSEMENT_DELETE_REQUEST:
        return { loading: true };
      case DISBURSEMENT_DELETE_SUCCESS:
        return { loading: false, success: true };
      case DISBURSEMENT_DELETE_FAIL:
        return { loading: false, error: action.payload };
      case DISBURSEMENT_DELETE_RESET:
        return {};
      default:
        return state;
    }
  };